;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "Loader",
  props: {
    title: {
      type: String,
      default: "Confirming payment"
    },
    altText: {
      type: String,
      default: "Loader img"
    },
    loaderImage: {
      type: String,
      default: "/iframev2/assets/img/png/loader.png"
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center pt-6"},[_c('h2',{staticClass:"text-3xl text-gray-500 font-semibold leading-[38.68px] text-center mb-9 sm:mb-16"},[_vm._v("\n    Confirming payment\n  ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center w-full py-4 min-h-80"},[_c('img',{staticClass:"animate-spin w-24",attrs:{"src":"/iframev2/assets/img/png/loader.png","alt":"Loader img"}})])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-76f7fef8", __vue__options__)
  } else {
    hotAPI.reload("data-v-76f7fef8", __vue__options__)
  }
})()}